import KundeLieferung from "@/entities/common/kunde_lieferung"
import BPLieferungKundeRequest from "@/entities/common/pending/bp_lieferung_kunde_request"
import RemoteResult from "@/entities/common/remote_result"
import IdRequest from "@/entities/common/request/id_request"
import router from "@/router"
import store from "@/store"
import Poster from "@/util/poster"
import RestPaths from "@/util/rest_paths"
import RouteNames from "@/util/route_names"
import BaseLogic from "../base_logic"
import MainLogic from "../main_logic"

export default class KundendatenLieferungLogic extends BaseLogic {
  insertWorking: boolean = false
  insertError: boolean = false
  bestellungCompleted: boolean = false
  formValid: boolean = true
  kundeNachname?: string = null
  kundeVorname?: string = null
  kundeEmail?: string = null
  kundeTelefon?: string = null
  kundeStrasse?: string = null
  kundePlz?: string = null
  kundeOrt?: string = null
  kundeAdresszusatz?: string = null
  kommentare?: string = null

  nachnameRules: any[] = [(v: any) => !!v || "Bitte Nachname angeben"]

  vornameRules: any[] = [(v: any) => !!v || "Bitte Vorname angeben"]

  emailRules: any[] = [
    (v: any) => !!v || "Bitte E-Mail angeben",
    (v: string) => /.+@.+\..+/.test(v) || "Bitte gültige E-Mail angeben",
  ]

  telefonRules: any[] = [(v) => !!v || "Bitte Telefon angeben"]

  strasseRules: any[] = [(v) => !!v || "Bitte Strasse angeben"]

  plzRules: any[] = [
    (v) => !!v || "Bitte PLZ angeben",
    (v: string) => /\d{5}/.test(v) || "Bitte gültige PLZ angeben",
  ]

  ortRules: any[] = [(v) => !!v || "Bitte Ort angeben"]

  init() {
    var ld = this.mainLogic.bestellungPending.lieferung

    if (ld.kundeNachname) {
      this.kundeNachname = ld.kundeNachname
    }
    if (ld.kundeVorname) {
      this.kundeVorname = ld.kundeVorname
    }
    if (ld.kundeStrasse) {
      this.kundeStrasse = ld.kundeStrasse
    }
    if (ld.kundePlz) {
      this.kundePlz = ld.kundePlz
    }
    if (ld.kundeOrt) {
      this.kundeOrt = ld.kundeOrt
    }
    if (ld.kundeAdresszusatz) {
      this.kundeAdresszusatz = ld.kundeAdresszusatz
    }
    if (ld.kundeTelefon) {
      this.kundeTelefon = ld.kundeTelefon
    }
    if (ld.kundeEmail) {
      this.kundeEmail = ld.kundeEmail
    }
  }

  weiter() {
    this.insertWorking = true
    this.insertError = false

    var request = new BPLieferungKundeRequest()
    request.id = store.state.user.identifier
    request.kundeNachname = this.kundeNachname
    request.kundeVorname = this.kundeVorname
    request.kundeTelefon = this.kundeTelefon
    request.kundeEmail = this.kundeEmail
    request.kundeStrasse = this.kundeStrasse
    request.kundePlz = this.kundePlz
    request.kundeOrt = this.kundeOrt
    request.kundeAdresszusatz = this.kundeAdresszusatz

    Poster.postUser<RemoteResult<any>>(
      RestPaths.bestellungpendingLieferungKunde,
      request
    )
      .then((response) => {
        if (response.data.success) {
          this.mainLogic.bestellungPending.lieferung.kundeNachname = this.kundeNachname
          this.mainLogic.bestellungPending.lieferung.kundeVorname = this.kundeVorname
          this.mainLogic.bestellungPending.lieferung.kundeTelefon = this.kundeTelefon
          this.mainLogic.bestellungPending.lieferung.kundeEmail = this.kundeEmail
          this.mainLogic.bestellungPending.lieferung.kundeStrasse = this.kundeStrasse
          this.mainLogic.bestellungPending.lieferung.kundePlz = this.kundePlz
          this.mainLogic.bestellungPending.lieferung.kundeOrt = this.kundeOrt
          this.mainLogic.bestellungPending.lieferung.kundeAdresszusatz = this.kundeAdresszusatz

          router.push({
            name: RouteNames.NEU.BESTAETIGEN_LIEFERUNG,
          })
        } else {
          this.insertError = true
        }
        this.insertWorking = false
      })
      .catch(() => {
        this.insertError = true
        this.insertWorking = false
      })
  }
}
